export const DEV_PHOENIX_API_PROXY_PATH = "/v1";
export const DEV_PHOENIX_WS_PROXY_URL_PATH = "/v1/ws";

const HTTPS_PROTOCOL = "https:";
const WS_PROTOCOL = "ws:";
const WSS_PROTOCOL = "wss:";

export const deriveWsUrlFromApi = (apiUrl: string): string => {
  if (!apiUrl) return "";
  try {
    const url = new URL(apiUrl);
    const protocol =
      url.protocol === HTTPS_PROTOCOL ? WSS_PROTOCOL : WS_PROTOCOL;
    return `${protocol}//${url.host}${DEV_PHOENIX_WS_PROXY_URL_PATH}`;
  } catch {
    return "";
  }
};

export const normalizeWsUrl = (wsUrl: string): string => {
  if (!wsUrl) return "";
  try {
    const url = new URL(wsUrl);
    if (url.pathname === "/ws") {
      url.pathname = DEV_PHOENIX_WS_PROXY_URL_PATH;
      return url.toString();
    }
    return wsUrl;
  } catch {
    return wsUrl;
  }
};

export const toDevProxyWsUrl = (origin: string): string => {
  const url = new URL(origin);
  url.protocol = url.protocol === HTTPS_PROTOCOL ? WSS_PROTOCOL : WS_PROTOCOL;
  url.pathname = DEV_PHOENIX_WS_PROXY_URL_PATH;
  url.search = "";
  url.hash = "";
  return url.toString();
};
